import { Pagination as AntPagenation } from 'antd';
import React, { Component } from 'react';
import { $Formutil, EasyField, FormItem } from 'react-antd-formutil';
import { connect } from 'react-formutil';
import { PaginationProps } from 'antd/lib/pagination';
import { printf } from 'utils/i18n';

import './style.scss';

interface PagenationProp extends PaginationProps {
    pageName?: string;
    pageSizeName?: string;
    defaultPageSize?: number;
    onPageChange?: (page: number) => void;
    onPageSizeChange?: (current: number, pageSize: number) => void;
}

class Pagination extends Component<PagenationProp & { $formutil: $Formutil }> {
    static defaultProps = {
        showQuickJumper: true,
        size: 'small',
        showTotal: total => {
            return printf(__('共%s条'), total);
        },
        showSizeChanger: true,
        defaultPageSize: 20,
        pageName: 'page',
        pageSizeName: 'pageSize'
    } as PagenationProp;

    render() {
        const { pageName, pageSizeName, onPageChange, onPageSizeChange, total, $formutil, ...props } = this.props;
        const { $params } = $formutil!;

        const current = $params[pageName!] as number;
        const pageSize = ($params[pageSizeName!] as number) || 20;

        return (
            <div className="pagination-root">
                <FormItem name={pageName} valuePropName="current" $onFieldChange={onPageChange} $defaultValue={1}>
                    <AntPagenation
                        total={total}
                        current={current}
                        pageSize={pageSize}
                        onShowSizeChange={onPageSizeChange}
                        {...props}
                    />
                </FormItem>
                <EasyField type="hidden" name={pageSizeName} $defaultValue={props.defaultPageSize} />
            </div>
        );
    }
}

export default connect(Pagination);
